import { useState } from 'react';
import type { PropsWithChildren } from 'react';

import { config } from '~app/config';

import { ampli } from '~entities/ampli';

import { AuthApiContext } from './auth-api-context';
import { GatewayAuthApi } from './gateway-auth-api';

export const AuthApiProvider = ({ children }: PropsWithChildren) => {
  const [authApi] = useState(
    () =>
      new GatewayAuthApi(config.authClientId, config.apiHost, (event) => {
        ampli.client.track(event);
      })
  );

  return (
    <AuthApiContext.Provider value={authApi}>
      {children}
    </AuthApiContext.Provider>
  );
};
